// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__22ZQ2","content":"GlobalSearch_content__1vobL"};